import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Servicio al que se imputa el gasto. Se admiten las dos formas del contrato:
 *
 * - **Número de pedido**: `B-A0DA99CA`.
 * - **Identificador de nodo**: el pedido más el índice del nodo dentro de la
 *   ruta, `B-A0DA99CA-1`.
 *
 * El backend resuelve las dos: busca primero el nodo y, si no existe, trata el
 * valor como número de pedido y engancha el gasto al tramo que se está
 * conduciendo o, si el servicio ya terminó, al último. Antes esta constante
 * exigía terminar en `-<número>` y el order hash se rechazaba aquí, sin llegar
 * nunca a la API.
 *
 * Se valida en el front para no gastar un 404 en un typo, pero de forma laxa: el
 * hash puede tener otras formas (`B-TRANSFER-BERTA-PROX-1` existe en los datos
 * de desarrollo), así que lo único que se exige son bloques alfanuméricos
 * separados por guiones y al menos un separador.
 */
const NODE_ID_PATTERN = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+$/;

export function normalizeNodeId(value: string): string {
  return value.trim().toUpperCase();
}

export function nodeIdValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value;

    if (typeof raw !== 'string' || raw.trim().length === 0) {
      return null; // La obligatoriedad la cubre Validators.required.
    }

    return NODE_ID_PATTERN.test(normalizeNodeId(raw)) ? null : { nodeId: true };
  };
}
